import SwapContainer from "@/components/shared/swap/SwapContainer";
import { useMyWalletAndAssets } from "@/hooks";
import type { WalletAsset } from "@/interfaces/asset";
import { queryClient } from "@/services/queryClient";
import { useAppSelector } from "@/store/hooks";
import { makeRequest } from "@/utils/makeRequest";
import { useEffect, useState } from "react";

const UserSwap = () => {
  const { user } = useAppSelector((state) => state.auth);
  const userId = user?.id ?? "";

  const [rates, setRates] = useState([]);

  const [selectedAsset, setSelectedAsset] = useState<WalletAsset>();
  const [isLoading, setIsLoading] = useState(false);

  const {
    data: wallet,
    isLoading: isLoadingWallet,
    isError,
  } = useMyWalletAndAssets(userId);

  const swap = async ({
    networkId,
    fromAssetId,
    toAssetId,
    amount,
    // otp,
    securityCode,
  }: {
    networkId: string;
    fromAssetId: string;
    toAssetId: string;
    amount: string;
    // otp: string;
    securityCode: string;
  }) => {
    setIsLoading(true);

    const payload = {
      networkId,
      fromAssetId,
      toAssetId,
      amountFrom: amount,
      // otp,
      securityCode,
    };

    try {
      await makeRequest.post("/blockchain/swap", payload);

      await queryClient.invalidateQueries({
        queryKey: ["wallet", userId],
      });

      await queryClient.invalidateQueries({
        queryKey: ["transactions", user?.id, 1],
      });
    } finally {
      setIsLoading(false);
    }
  };

  const assets: WalletAsset[] = wallet?.assets || [];

  useEffect(() => {
    if (assets.length > 0 && !selectedAsset) {
      setSelectedAsset(assets[0]);
    }
  }, [assets, selectedAsset]);

  return (
    <div>
      <SwapContainer
        wallet={wallet!}
        assets={wallet?.assets ?? []}
        initialAsset={selectedAsset}
        isLoading={isLoading}
        onSwap={swap}
      />
    </div>
  );
};

export default UserSwap;
